import * as React from 'react';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import { ContactCard } from './components/ContactCard/ContactCard';
import { LandlordPreviewMode } from './components/LandlordPreviewMode/LandlordPreviewMode';
import { LandlordProfile } from './components/LandlordProfile';
import { RentalPrice } from './components/RentalPrice';
import styles from './ContactLandlordMobile.module.css';

export const ContactLandlordMobile = () => {
  const { listingDetails } = ListingDetailsContext.useContext();

  return (
    <section className={styles.root}>
      <div className={styles.header}>
        <RentalPrice />
        <LandlordProfile />
      </div>
      {listingDetails.isPreviewMode ? <LandlordPreviewMode /> : <ContactCard />}
    </section>
  );
};
